<template>
  <div>
    <!-- <e-header :step="3" @next="postContract" /> -->
    <div class="aliform" v-html="aliform" v-show="false"></div>
    <div class="ElectronicDocumentsPDF">
      <div class="left-box">
        <div class="left-box-title">第一步：选择签署方</div>
        <div class="user_box">
          <div v-for="item in signersList" :key="item.id">
            <div
              class="item"
              :class="{ active: item.id === activeIndex }"
              v-if="item.type === 'PERSON'"
              @click="activeIndex = item.id"
            >
              <div class="item_l">
                <div class="icon">个</div>
                <div class="name single-line" style="width: 140px">
                  {{ item.operatorName }}
                </div>
              </div>
              <div class="item_r">{{ tuozhuaishuliang(item) }}</div>
            </div>

            <div
              class="item qiye"
              :class="{ active: item.id === activeIndex }"
              v-else
              @click="activeIndex = item.id"
            >
              <div class="item_l">
                <div class="icon">企</div>
                <div class="name">
                  <p class="single-line" style="width: 140px">{{ item.name }}</p>
                  <p class="jingbanren">经办人：{{ item.operatorName }}</p>
                </div>
              </div>
              <div class="item_r">{{ tuozhuaishuliang(item) }}</div>
            </div>
          </div>
        </div>
        <div class="left-box-title solid">第 2 步：拖拽至文件区域</div>
        <div class="yinzhangBox" v-if="activeIndex">
          <div
            class="yinzhangBox_item"
            :class="{ yinzhangBox_item2: activeItem.type === 'ORG' }"
            draggable="true"
            @dragstart="handleDragStart('yinzhang')"
          >
            <div
              class="img"
              :style="`--img:url(${
                activeItem.type === 'ORG'
                  ? require('@/assets/image/yinzhang.png')
                  : require('@/assets/image/yinzhang2.png')
              })`"
            ></div>
            <div class="text">签署区/盖章区</div>
          </div>

          <div
            class="yinzhangBox_item"
            :class="{ yinzhangBox_item2: activeItem.type === 'ORG' }"
            draggable="true"
            @dragstart="handleDragStart('qifeng')"
          >
            <div
              class="img"
              :style="`--img:url(${
                activeItem.type === 'ORG'
                  ? require('@/assets/image/qifeng.png')
                  : require('@/assets/image/qifeng2.png')
              })`"
            ></div>
            <div class="text">骑缝章</div>
          </div>
          <div style="height: 38rpx; display: flex; align-items: center; padding: 0 16px">
            <el-checkbox @change="signDateBean = !signDateBean" :value="signDateBean"
              >显示签署日期</el-checkbox
            >
          </div>
        </div>
        <div class="yinzhangBox" v-else>请选择签署方</div>
      </div>
      <div class="content">
        <ScrollPager :total="numPages" :nowPage="nowPage" canScroll class="scroll-box">
          <template v-slot:default="{ page: p }">
            <div
              class="box"
              :style="`width:${pdfWidth}px`"
              :key="p"
              @dragover.prevent
              @drop="(e) => handleDrop(e, p)"
            >
              <pdf :src="pdfSrc" :page="p" style="width: 100%" @error="error" />
              <div class="signersBox">
                <div
                  class="yinzhang"
                  :class="{ yinzhangqiye: item.data.type === 'ORG' }"
                  :style="`left:${item.x}px;top:${item.y}px;height:${itemHeight}px;width:${itemWidth}px;`"
                  v-for="item in yinzhangList"
                  :key="item.id"
                  v-show="item.page === p"
                  draggable="true"
                  @dragstart="moveStart(item, $event, 'yinzhang')"
                >
                  <div class="yinzhang_top">
                    <div class="name single-line">
                      {{ item.data.name || item.data.operatorName }}
                    </div>
                  </div>
                  <div class="yinzhang_bottom" @click="deleteyinzhang(item)">删除</div>
                  <div class="yinzhang_content">
                    <img
                      class="img"
                      v-if="item.data.type === 'ORG'"
                      src="@/assets/image/yinzhang.png"
                      alt=""
                      srcset=""
                    />
                    <img
                      v-else
                      class="img"
                      src="@/assets/image/yinzhang2.png"
                      alt=""
                      srcset=""
                    />
                    <div class="text">签署区/盖章区</div>
                  </div>
                </div>

                <div
                  class="qifeng"
                  :class="{ yinzhangqiye: item.data.type === 'ORG' }"
                  :style="`left:${item.x}px;top:${item.y}px;height:${sealHeight}px;width:${sealWidth}px;`"
                  v-for="item in qifengList"
                  :key="item.id"
                  v-show="item.page === p"
                  draggable="true"
                  @dragstart="moveStart(item, $event, 'qifeng')"
                >
                  <div class="qifeng_top">
                    <div class="name single-line">
                      {{ item.data.name || item.data.operatorName }}
                    </div>
                  </div>
                  <div class="qifeng_bottom" @click="deleteqifeng(item)">删除</div>
                  <div class="qifeng_content">
                    <img
                      class="img"
                      v-if="item.data.type === 'ORG'"
                      src="@/assets/image/qifeng.png"
                      alt=""
                      srcset=""
                    />
                    <img
                      v-else
                      class="img"
                      src="@/assets/image/qifeng2.png"
                      alt=""
                      srcset=""
                    />
                    <div class="text">骑缝章</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </ScrollPager>
      </div>
      <div class="right-box">
        <pdfYulan
          :pdfSrc="pdfSrc"
          v-model="nowPage"
          :title="subject"
          @changePage="changePage"
        />
      </div>
    </div>
    <mElectronicFooter
      class="footerBottom"
      @nextClick="postContract"
      :disabledNext="disabledNext"
    />
    <hetongbuy ref="hetongbuy" @success="tijiao" />
  </div>
</template>

<script>
// import eHeader from "./components/eHeader.vue"
import { mapState, mapActions } from "vuex";
import hetongbuy from "@/components/hetongbuy/hetongbuy.vue";
import mElectronicFooter from "@/components/mElectronicFooter.vue";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import ScrollPager from "@/components/ScrollPager/index.vue";
// pdf预览
import pdf from "vue-pdf";

import pdfYulan from "./pdfYulan/pdfYulan.vue";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export default {
  name: "home",
  components: {
    pdf,
    // eHeader,
    hetongbuy,
    mElectronicFooter,
    pdfYulan,
    ScrollPager,
  },
  data() {
    return {
      itemWidth: 120, //印章宽高
      itemHeight: 120,
      sealWidth: 58, // 骑缝章宽高
      sealHeight: 118,

      src: "",
      currentPage: 1, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      scale: 100,
      pageRotate: 0,
      active: "",
      sealList: [], // 骑缝章列表
      sealActive: "",
      signers: [],
      aliform: "",
      loadedRatio: 0,
      loading: false,

      // pdf 总宽度
      pdfWidth: 0,
      pdfHeight: 0,
      //  pdf 总页数
      numPages: 0,
      nowPage: 1,
      activeIndex: 0,
      // 拖动的元素类型
      DragType: null,
      //  拖动的元素id
      moveId: null,
      // 拖动元素的偏移
      dragOffset: { x: 0, y: 0 },
      // 印章列表
      yinzhangList: [],
      // 骑缝章列表
      qifengList: [],
      //拖动元素的类型
      moveType: null,
      signDateBean: false,
    };
  },
  created() {},
  watch: {
    loadedRatio: {
      handler(newValue) {
        if (newValue == 1) {
          console.log("加载完毕");
          this.loading.close();
        }
      },
      deep: true, // 深度监听，确保对象内部属性变化也会触发
    },
    pdfSrc: {
      async handler(src) {
        if (!src) return;
        try {
          // 使用验证方法判断 PDF 是否可以加载
          const doc = await this.yanzhengPdf(src);

          // 获取页面尺寸
          const page = await doc.getPage(1);
          const viewport = page.getViewport({ scale: 1 });
          this.pdfWidth = viewport.width;
          this.pdfHeight = viewport.height;

          // 加载第一页或其他后续操作
          this.getPdfPage();
        } catch (error) {
          console.error("Failed to load PDF:", error);
          this.error();
        }
      },
      deep: false, // 如果pdfSrc是对象，比如 { url: '' } 就留着，否则可以去掉
      immediate: true, // 看你需不需要初始化就调用
    },
  },
  computed: {
    files() {
      return this.$store.state.ElectronicDocumentsAdd.files;
    },
    ...mapState({
      subject: (state) => state.ElectronicDocumentsAdd.subject,
      signersList: (state) => state.ElectronicDocumentsAdd.signersList,
      insuranceSelect: (state) => state.insuranceSelect,
    }),

    activeItem() {
      return this.signersList.find((res) => res.id === this.activeIndex);
    },
    // activeIndex() {
    //   return this.signerList.findIndex((item) => item.positionId == this.active);
    // },
    sealActiveIndex() {
      return this.sealList.findIndex((item) => item.positionId == this.sealActive);
    },
    disabledNext() {
      return false;
    },
    pdfSrc() {
      if (this.files.length > 0) {
        return this.files[0].downloadUrl;
      }
      return "";
    },
  },
  async mounted() {
    // this.loading = this.$loading({
    //   lock: true,
    //   text: '合同文件加载中，请耐心等待',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // });
  },
  methods: {
    ...mapActions("ElectronicDocumentsAdd", ["clearFiles"]),
    ...mapActions("hetongqianshu", ["setStep"]),
    // 拖拽的数量
    tuozhuaishuliang({ id }) {
      return [...this.yinzhangList, ...this.qifengList].filter(
        (item) => item.data.id === id
      ).length;
    },
    changePage(page) {
      console.log("page", page);
      this.nowPage = page;
    },
    getPdfPage(page) {
      pdf
        .createLoadingTask({
          url: this.pdfSrc,
        })
        .promise.then((pdfDoc) => {
          this.numPages = pdfDoc.numPages;
        });
    },
    postContract() {
      const ContractData = this.getContractData();

      for (const signer of ContractData.signers) {
        if (!signer.signFields || signer.signFields.length === 0) {
          this.$message.error(`请设置 ${signer.name || signer.operatorName} 的签署区`);
          return; // 终止整个方法执行
        }
      }

      // 所有签署人都已设置签署区，继续后续操作
      this.$refs.hetongbuy.show();
    },
    async tijiao({ voucherId, paymentMethod, price }) {
      try {
        let ContractData = this.getContractData();
        //  如果合同保id不为零  请求参数加上合同保参数  （本地设定合同保id为0 是暂不选择合同宝）
        if (ContractData.insuranceId == 0) {
          delete ContractData.insuranceId;
          delete ContractData.insuranceVersion;
        }
        let parm = { ...ContractData, voucherId, paymentMethod };
        const { status, data, info } = (await this.$api.postContract(parm)) || {};
        if (status === 201 || status === 200) {
          if (paymentMethod == 2 && price) {
            this.aliform = data;
            this.$nextTick(() => {
              const forms = Array.from(document.forms);
              const alipayForm = forms.find((form) =>
                form.action.includes("alipay.com/gateway.do")
              );
              if (alipayForm) {
                alipayForm.submit();
              } else {
                console.warn("找不到支付宝表单");
              }
              // document.forms[0].submit(); //重点--这个才是跳转页面的核心,获取第一个表单并提交
            });
            return;
          }
          this.$message({
            message: info,
            type: "success",
          });
          this.$refs.hetongbuy.close();
          this.$store.dispatch("hetongqianshu/clearData", { type: "toStep7" });
          // this.setStep(7);
        } else {
          this.$message({
            message: info,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 左边列表拖拽到合同
    handleDragStart(type) {
      this.DragType = type;
    },
    // 印章在合同移动
    moveStart({ id }, event, moveType) {
      const rect = event.target.getBoundingClientRect();
      this.dragOffset.x = event.clientX - rect.left;
      this.dragOffset.y = event.clientY - rect.top;
      this.moveId = id;
      this.moveType = moveType;
    },
    // 接收拖拽
    handleDrop(event, page) {
      //  获取印章蒙版
      const pdfBoxes = document.querySelectorAll(".signersBox");
      // 获取拖拽到哪个蒙版上了
      const contractPanel = pdfBoxes[page - 1];
      const rect = contractPanel.getBoundingClientRect();
      // 获取 contractPanel 元素相对于视口的位置和大小（返回一个 DOMRect 对象）

      let x = event.clientX - rect.left + window.scrollX;
      // 计算鼠标点击位置相对于 contractPanel 左上角的横坐标（x）
      // event.clientX 是相对于视口的 x 坐标
      // rect.left 是 contractPanel 左边界相对于视口的 x 距离
      // window.scrollX 是页面水平滚动偏移量，用于修正视口滚动后的偏差

      let y = event.clientY - rect.top + window.scrollY;
      // 计算鼠标点击位置相对于 contractPanel 左上角的纵坐标（y）
      // event.clientY 是相对于视口的 y 坐标
      // rect.top 是 contractPanel 顶部边界相对于视口的 y 距离
      // window.scrollY 是页面垂直滚动偏移量，用于修正视口滚动后的偏差
      // 如果拖拽的是印章  印章列表添加数据
      if (this.DragType === "yinzhang") {
        this.yinzhangList.push({
          data: { ...this.activeItem },
          id: this.$utils.guid(),
          page,
          x,
          y,
        });
      }
      // 拖拽的骑缝章
      if (this.DragType === "qifeng") {
        this.qifengList.push({
          data: { ...this.activeItem },
          id: this.$utils.guid(),
          page,
          x: rect.width - this.sealWidth,
          y,
        });
      }
      // 如果有moveId  就是移动，更新元素坐标
      if (this.moveId) {
        if (this.moveType === "yinzhang") {
          const item = this.yinzhangList.find((item) => item.id === this.moveId);
          if (item) {
            item.x = Math.max(
              0,
              Math.min(x - this.dragOffset.x, rect.width - this.itemWidth)
            );
            item.y = Math.max(
              0,
              Math.min(y - this.dragOffset.y, rect.height - this.itemHeight)
            );
            item.page = page;
          }
        }
        if (this.moveType === "qifeng") {
          const item = this.qifengList.find((item) => item.id === this.moveId);
          if (item) {
            item.y = Math.max(
              0,
              Math.min(y - this.dragOffset.y, rect.height - this.itemHeight)
            );
            item.page = page;
          }
        }
      }
      //  重置
      this.DragType = null;
      this.moveId = null;
      this.dragOffset = { x: 0, y: 0 };
      this.moveType = null;
    },
    //  删除印章
    deleteyinzhang({ page, id }) {
      this.yinzhangList = this.yinzhangList.filter(
        (item) => item.page !== page || item.id !== id
      );
    },
    deleteqifeng({ page, id }) {
      this.qifengList = this.qifengList.filter(
        (item) => item.page !== page || item.id !== id
      );
    },
    // 格式化数据  转换成后台需要的数据结构
    getContractData() {
      const subject = this.subject;
      const files = this.files.map((res) => ({ fileId: res.fileId, fileName: res.name }));
      const fileId = files[0]?.fileId; //文件id

      let signers = this.signersList;
      signers.forEach((element) => {
        const id = element.id;
        let yinzhang = this.yinzhangList.filter((item) => item.data.id === id);
        const yinzhangGeShi = yinzhang.map((res) => {
          let data = {
            fileId,
            posX: Math.max(0, res.x - 0 + this.itemWidth / 2),
            posY: Math.max(0, this.pdfHeight - res.y - this.itemHeight / 2),
            posPage: res.page,
            signType: 1,
          };
          if (this.signDateBean) {
            data.signDateBean = {
              format: "yyyy年MM月dd日",
              posPage: res.page,
              posX: Math.max(0, res.x),
              posY: Math.max(0, this.pdfHeight - res.y - this.itemHeight),
            };
          }
          return data;
        });
        let qifeng = this.qifengList.filter((item) => item.data.id === id);
        const qifengGeShi = qifeng.map((res) => ({
          fileId,
          posY: Math.max(0, this.pdfHeight - res.y - this.sealHeight / 2),
          posPage: res.page,
          signType: 2,
        }));
        const signFields = [...yinzhangGeShi, ...qifengGeShi];
        element.signFields = signFields;
      });
      const { insuranceId, insuranceVersion } = this.insuranceSelect;
      return {
        subject, //合同名称
        files, //文件信息
        signers, //签署方信息
        insuranceId, //合同保障ID
        insuranceVersion, //合同保障版本
        voucherId: 0, //代金券ID
        paymentMethod: 1, //支付方式
      };
    },
    error(res) {
      this.$alert("合同文件错误，请重新上传", "提示", {
        confirmButtonText: "确定",
        type: "error",
        callback: (action) => {
          this.clearFiles();
          this.setStep(1);
        },
      });
    },
    // 验证pdf地址是否有效
    yanzhengPdf(url) {
      return pdfjsLib.getDocument({
        url,
      }).promise;
    },
  },
};
</script>

<style scoped lang="scss">
.ElectronicDocumentsPDF {
  display: flex;
  width: 100%;
  ::v-deep.el-select {
    position: relative !important;
    &-dropdown {
      position: absolute !important;
      right: 0px !important;
      top: 28px !important;
    }
  }
  $boxHeight: calc(100vh - 72px - 64px - 10px - 16px);
  $liangceW: 240px;
  $PERSONColor: #faad15;
  $PERSONColor_bg: #fff4e3;
  $ORGColor: #0062ff;
  $ORGColor_bg: #e8f3ff;
  .left-box {
    background: #fff;
    width: 240px;
    padding: 0 16px;
    height: $boxHeight;
    left: 0;
    .solid {
      border-top: 1px solid #f2f3f5;
      margin-top: 24px;
    }
    &-title {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;

      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #262626;
    }
    .user_box {
      .item {
        width: 100%;
        height: 44px;
        border-radius: 4px;
        opacity: 1;

        /* 自动布局 */
        display: flex;

        padding: 0 10px;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        &_l {
          display: flex;
          gap: 6px;
          align-items: center;
          .icon {
            width: 20px;
            height: 20px;
            border-radius: 4px;
            background: $PERSONColor;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
          }
          .name {
            font-family: "Noto Sans SC";
            font-size: 14px;

            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: #262626;
            line-height: 20px;
          }
        }
        &_r {
          font-size: 14px;
          color: #262626;
        }
      }
      .item.active {
        background: $PERSONColor_bg;
      }
      .qiye {
        height: 62px;
        .icon {
          background-color: $ORGColor;
          align-self: flex-start;
        }
        .jingbanren {
          font-family: "Noto Sans SC";
          font-size: 12px;
          font-weight: normal;
          line-height: normal;
          letter-spacing: 0em;

          font-variation-settings: "opsz" auto;
          font-feature-settings: "kern" on;
          color: #999999;
        }
      }
      .qiye.active {
        background: $ORGColor_bg;
      }
    }
    .yinzhangBox {
      display: flex;
      flex-direction: column;
      gap: 16px;
      &_item {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        background: $PERSONColor_bg;
        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        font-size: 14px;
        color: #262626;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 0 16px;
        cursor: move;
        .text {
          user-select: none; /* 防止文字被选中 */
        }
        .img {
          background-image: var(--img);
          background-size: 100%;
          width: 16px;
          height: 16px;
        }
        &:active {
          border: 1px dashed $PERSONColor;
        }
      }
      &_item2 {
        background: $ORGColor_bg;
        &:active {
          border: 1px dashed $ORGColor;
        }
      }
    }
  }

  .right-box {
    background: #fff;
    width: $liangceW;
    padding: 0 16px;
    height: $boxHeight;
    right: 0;
  }
  .content {
    flex: 1;
    overflow-y: auto;
    height: $boxHeight;
  }
  .scroll-box {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: $boxHeight;
  }
  .box {
    margin: 0 auto;
    position: relative;
    width: 595px;
    .signersBox {
      position: absolute;
      width: 100%;
      height: 100%;
      // background: rgba($color: #000, $alpha: 0.5);
      z-index: 2;
      top: 0px;
      left: 0px;
      .yinzhang {
        $left: 0px;
        $top: 0px;

        background: $PERSONColor_bg;

        box-sizing: border-box;
        border: 0.5px dashed $PERSONColor;
        position: absolute;
        left: $left;
        top: $top;
        &_content {
          display: flex;
          gap: 5px;
          position: absolute;
          bottom: 10px;
          right: 10px;
          .img {
            width: 10px;
            height: 10px;
          }
          .text {
            font-family: "Noto Sans SC";
            font-size: 10px;
            letter-spacing: 0em;

            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: #262626;
          }
        }
        &_top {
          width: 100%;
          height: 25px;
          position: absolute;
          top: -25px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          // z-index: 3;
          background: $PERSONColor;
          color: #fff;
          border-radius: 4px 4px 0 0;
          font-size: 10px;
          display: none;
        }
        &_bottom {
          width: 40px;
          height: 20px;
          position: absolute;
          bottom: -20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba($color: #000000, $alpha: 0.5);
          color: #fff;
          font-size: 10px;
          cursor: pointer;
          left: 0;
          right: 0;
          margin: auto;
          display: none;
        }
        &:hover {
          .yinzhang_top {
            display: flex;
          }
          .yinzhang_bottom {
            display: flex;
          }
        }
      }

      .qifeng {
        $left: 0px;
        $top: 0px;
        background: $PERSONColor_bg;
        position: absolute;
        left: $left;
        top: $top;
        box-sizing: border-box;
        border: 0.5px dashed $PERSONColor;
        &_top {
          width: 100%;
          height: 25px;
          position: absolute;
          top: -25px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          // z-index: 3;
          background: $PERSONColor;
          color: #fff;
          border-radius: 4px 4px 0 0;
          font-size: 10px;
          display: none;
        }
        &_bottom {
          width: 40px;
          height: 20px;
          position: absolute;
          bottom: -20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba($color: #000000, $alpha: 0.5);
          color: #fff;
          font-size: 10px;
          cursor: pointer;
          left: 0;
          right: 0;
          margin: auto;
          display: none;
        }
        &_content {
          display: flex;
          gap: 5px;
          position: absolute;
          bottom: 10px;
          justify-content: center;
          width: 100%;
          .img {
            width: 10px;
            height: 10px;
          }
          .text {
            font-family: "Noto Sans SC";
            font-size: 10px;
            letter-spacing: 0em;

            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: #262626;
          }
        }
        &:hover {
          .qifeng_top {
            display: flex;
          }
          .qifeng_bottom {
            display: flex;
          }
        }
      }
      .yinzhangqiye {
        background: $ORGColor_bg;
        border: 0.5px dashed $ORGColor;
        .yinzhang_top,
        .qifeng_top {
          background: $ORGColor;
        }
      }
    }
  }
}
.footerBottom {
  margin-top: 16px;
}
</style>
